import { buildScopedI18n } from '../../utils/buildScopedI18n';
import scheduleEsCL from './locales/es-CL.json';
import scheduleEnUS from './locales/en-US.json';
import schedulePtBR from './locales/pt-BR.json';

export const scheduleI18n = buildScopedI18n({
  esCL: scheduleEsCL,
  enUS: scheduleEnUS,
  ptBR: schedulePtBR,
});
